import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

import { Language } from "@app/core/models";
import { AppStateBase } from "./app-state.interface";

export interface AppFacadeInterface {
  isAuthenticated(): Observable<boolean>;
  getLanguage(): Observable<Language>;
  setAuthenticated(status: boolean): void;
  setLanguage(lang: Language): void;
  getError(): Observable<boolean>;
  setError(): void;
  resetError(): void;
  shouldRedirectUser(hasDOB: boolean, verifiedNegative: boolean, consentMarked: boolean): boolean;
  goToConfirmDateOfBirth(): void;
  goToUnderage(): void;
  goToMarketingConsent(): void;
}

@Injectable()
export class AppFacade implements AppFacadeInterface {
  constructor(private router: Router, private state: AppStateBase) {}

  isAuthenticated(): Observable<boolean> {
    return this.state.isAuthenticated();
  }

  getLanguage(): Observable<Language> {
    return this.state.getLanguage();
  }

  setAuthenticated(status: boolean): void {
    this.state.setAuthenticated(status);
  }

  setLanguage(lang: Language): void {
    this.state.setLanguage(lang);
  }

  getError(): Observable<boolean> {
    return this.state.getError();
  }

  setError(): void {
    this.state.setError();
  }

  resetError(): void {
    this.state.resetError();
  }

  goToConfirmDateOfBirth(): void {
    this.router.navigate(["/confirm-date-of-birth"]);
  }

  goToUnderage(): void {
    this.router.navigate(["/confirm-date-of-birth/underage"]);
  }

  goToMarketingConsent() {
    this.router.navigate(["/user-profile/marketing-consent"]);
  }

  /**
   * Checks user status and redirects if necessary.
   * Returns true if a redirect occurred, false otherwise.
   */
  shouldRedirectUser(
    hasDOB: boolean,
    verifiedNegative: boolean,
    consentMarked: boolean
  ): boolean {
    if (!hasDOB) {
      this.goToConfirmDateOfBirth();
      return true;
    }

    if (verifiedNegative) {
      this.goToUnderage();
      return true;
    }

    if (!consentMarked) {
      this.goToMarketingConsent();
      return true;
    }

    return false;
  }
}
